import api from '..'
import { IEnrolModel } from 'models/enrol.model'

export interface IEnrolCreate {
  courseId: number
  note: string
}

const enrolCreate = (enrol: IEnrolCreate) => {
  return api.post<IEnrolModel>('enrols', enrol)
}

export default enrolCreate
